import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SharedComponentsModule } from '../../SharedComponent/shared-components.module';
import { DataService } from 'src/app/Services/Data/data.service';
//containers
import { TemplateSettingsListComponent } from './container/template-settings-list.component';
//components
import { TemplateSettingsFormComponent } from './component/template-settings-form.component';
//services
import { TemplateSettingsService } from './template-settings.service';

const routes: Routes = [
  { path: 'template_settings', component: TemplateSettingsListComponent },
  { path: 'template_settings_form', component: TemplateSettingsFormComponent }
  /*{
    path: 'template_settings',
    children: [
      { path: '', component: TemplateSettingsListComponent},
      { path: 'template_settings_form', component: TemplateSettingsFormComponent }
    ]
  }*/
];

@NgModule({
  declarations: [TemplateSettingsListComponent, TemplateSettingsFormComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    RouterModule.forRoot(routes, { useHash: true })
  ],
  providers: [TemplateSettingsService, DataService],
  exports: [TemplateSettingsListComponent],
  bootstrap: [TemplateSettingsListComponent, TemplateSettingsFormComponent]
})
export class TemplateSettingsModule {}
